const Footer = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="bg-white min-h-[84px] py-5 px-[25px] flex items-center justify-end">
      <div className="flex flex-row flex-wrap justify-end gap-x-3 gap-y-2.5">
        {children}
      </div>
    </div>
  );
};

export default Footer;
